import type { AdminAppealOutcome } from '@carcheck/shared';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import type { ReactElement } from 'react';
import { Controller, type Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { ResolveFormValues } from '../../_lib/resolveAppealSchema';

/**
 * Outcome `<Select>` for the resolve dialog (AUT-130). Options come from
 * the shared `ADMIN_APPEAL_OUTCOMES` const (passed in — never hand-typed);
 * labels resolve via `appeals.resolveDialog.outcome.<value>`. Selecting an
 * outcome drives which conditional field group the dialog renders.
 */
export interface OutcomeSelectProps {
  control: Control<ResolveFormValues>;
  loading: boolean;
  outcomes: readonly AdminAppealOutcome[];
}

export const OutcomeSelect = ({ control, loading, outcomes }: OutcomeSelectProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <Controller
      name="outcome"
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          select
          fullWidth
          size="small"
          disabled={loading}
          label={t('appeals.resolveDialog.outcomeLabel')}
        >
          {outcomes.map((value) => (
            <MenuItem key={value} value={value}>
              {t(`appeals.resolveDialog.outcome.${value}`)}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
};
